var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-store-locator-side-panel" },
    [
      _c("button", {
        ref: "sidePanelCloseButton",
        class: _vm.getCloseIcon,
        attrs: { "data-analytics_available_call": "0" },
        on: { click: _vm.onClosePanel },
      }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }